<!--
* 组件名 : 侧滑导航
* 开发者 : HN
*
* 参数:  无
*
* 事件:  null
*
*
-->
<template>
  <section
    v-if="isMenuShow"
    id="menu"
    ref="menu"
    :class="[isMenuShow ? 'show' : '']"
  >
    <div class="menu-container" :class="[isShowAside ? 'open' : '']">
      <!-- 菜单背景 -->
      <menuBgs :isActiveMenuBg="isActiveMenuBg" />

      <!-- 主菜单 -->
      <menuNav @changeMenuBg="change_menu_bg" />

      <!-- 右侧logo+底部菜单 -->
      <menuLeft />

      <!-- 左侧关闭按钮+分享 -->
      <menuRight />
    </div>

    <!-- 版权署名页 -->
    <copyright />
  </section>
</template>

<script>
import "./index.scss";
import { mapState  } from "vuex";
import menuBgs from "./components/menu-bgs/index.vue";
import menuLeft from "./components/menu-left/index.vue";
import menuRight from "./components/menu-right/index.vue";
import menuNav from "./components/menu-nav/index.vue";
import copyright from "./components/copyright/index.vue";

export default {
  components: {
    menuBgs,
    menuLeft,
    menuRight,
    menuNav,
    copyright,
  },
  computed: {
    ...mapState("global", ["isShowAside"]),
  },
  data() {
    return {
      isMenuShow: false,
      show: false,
      isActiveMenuBg: 0,
    };
  },

  mounted() {
    this.isMenuShow = this.$route.name === "home" ? false : true;
  },
  watch: {
    $route(to){
      this.isMenuShow = to.name === "home" ? false : true;
    }
  },
  methods: {
    change_menu_bg(current) {
      this.isActiveMenuBg = current;
    },
  },
};
</script>
